import {
  FILTER_OPERATOR,
  createPaginatedQueryTranslation,
  serializeRequestParams,
  type UrlPageQueryState,
} from "@SeemplicityDev/shared";
import type { AnalystRunFields } from "./types";

export const RUN_FIELD = {
  RUN_ID: "run_id",
  COMPLETED_AT: "completed_at",
  SUGGESTED_PRIORITY: "suggested_priority",
  REASONING_SUMMARY: "reasoning_summary",
  AGENT_INSTANCE_ID: "agent_instance_id",
  ANALYST_NAME: "analyst_name",
  AGENT_TYPE: "agent_type",
  FINDING_TITLE: "finding_title",
} as const satisfies Record<string, keyof AnalystRunFields>;

export type RunField = (typeof RUN_FIELD)[keyof typeof RUN_FIELD];

export const SORTABLE_COLUMN_IDS: RunField[] = [
  RUN_FIELD.COMPLETED_AT,
  RUN_FIELD.SUGGESTED_PRIORITY,
  RUN_FIELD.ANALYST_NAME,
];

export const DEFAULT_PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
];

export interface AnalystRunsState extends UrlPageQueryState {
  analystTypes: string[];
  analystIds: string[];
}

export const DEFAULT_ANALYST_RUNS_STATE: AnalystRunsState = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  sortField: RUN_FIELD.COMPLETED_AT,
  sortDesc: true,
  analystTypes: [],
  analystIds: [],
};

const AGENT_TYPE_PATTERN = /^[a-z][a-z0-9_]*$/i;

export const ANALYST_RUNS_FILTER_KEYS = ["analystTypes", "analystIds"] as const;

export const analystRunsQuery =
  createPaginatedQueryTranslation<AnalystRunsState>({
    defaults: DEFAULT_ANALYST_RUNS_STATE,
    sortableFields: SORTABLE_COLUMN_IDS,
    pageSizes: PAGE_SIZE_OPTIONS.map(({ value }) => value),
    maxPage: 10000,
    filters: {
      analystTypes: {
        field: RUN_FIELD.AGENT_TYPE,
        operator: FILTER_OPERATOR.IN,
        isAllowed: (value) => AGENT_TYPE_PATTERN.test(value),
        toWire: (value) => value.toLowerCase(),
      },
      analystIds: {
        field: RUN_FIELD.AGENT_INSTANCE_ID,
        operator: FILTER_OPERATOR.IN,
      },
    },
  });

export { serializeRequestParams };
